import * as React from 'react';
import { getConfig } from '../../helpers';
import Note from '../_common/note';


function ReleaseNote({ title, noteParagraph, linkText, linkHref, dateAdded, dateUpdated, isKensho }: ReleaseNoteProps) {
    let showNote = true;

    const past = new Date().getTime() - getConfig('components.flagVisibilityCutoffTime');
    const today = new Date().getTime();
    const showTitle = (!isKensho && title !== '') ? title : '';

    if (dateUpdated && dateAdded) {
        const added = Date.parse(dateAdded);
        const lastUpdated = Date.parse(dateUpdated);
        showNote = ((lastUpdated > past && lastUpdated <= today) || (added > past));
    }

    if (!showNote) return null;

    return (
        <Note title={showTitle} noteParagraph={noteParagraph} linkHref={linkHref} linkText={linkText} />
    );
}

export default React.memo(ReleaseNote);
